import _extends from "@babel/runtime/helpers/extends";
import Service from './Service';
import { DOCS_ENVS } from '../utils/consts';
export { Service as default };
export var createService = function createService(config) {
  return {
    dmV1: new Service(_extends({}, config, {
      baseURL: config.getBaseURL('DOCS_API_V1'),
      headers: _extends({
        'x-ads-region': config.region
      }, config.getHeaders('DOCS_API_V1'))
    })),
    dmV2: new Service(_extends({}, config, {
      baseURL: config.getBaseURL('DOCS_API_V2'),
      headers: _extends({
        'x-ads-region': config.region
      }, config.getHeaders('DOCS_API_V2'))
    })),
    dmV3: new Service(_extends({}, config, {
      baseURL: config.getBaseURL('DOCS_API_V3'),
      headers: _extends({
        'x-ads-region': config.region
      }, config.getHeaders('DOCS_API_V3'))
    })),
    pkgV1: new Service(_extends({}, config, {
      baseURL: config.getBaseURL('PKG_API_V1'),
      headers: _extends({
        'x-ads-region': config.region
      }, config.getHeaders('PKG_API_V1'))
    })),
    cpV1: new Service(_extends({}, config, {
      headers: config.getHeaders('DOCS_API_CPV1'),
      baseURL: config.getBaseURL('DOCS_API_CPV1')
    })),
    exportV1: new Service(_extends({}, config, {
      headers: config.getHeaders('EXPORT_API_V1'),
      baseURL: config.getBaseURL('EXPORT_API_V1')
    })),
    exportV2: new Service(_extends({}, config, {
      headers: config.getHeaders('EXPORT_API_V2'),
      baseURL: config.getBaseURL('EXPORT_API_V2')
    })),
    reportV2: new Service(_extends({}, config, {
      withRequestId: false,
      headers: config.getHeaders('REPORT_API_V2'),
      baseURL: config.getBaseURL('REPORT_API_V2')
    })),
    // Connect to Apigee host directly
    apigee: new Service(_extends({}, config, {
      withRequestId: false
    })),
    // Markup
    markup: new Service(_extends({}, config, {
      withRequestId: false,
      baseURL: config.getEnv('MARKUP_HOST'),
      headers: _extends({}, config.getHeaders('MARKUP_HOST'), {
        Accept: 'application/vnd.plangrid+json; version=1',
        'x-requested-by': 'ACS-Docs SDK JS'
      })
    })),
    // Revit Upgrade
    rvtUpgradeV1: new Service(_extends({}, config, {
      withRequestId: true,
      baseURL: config.getBaseURL('RVT_UPGRADE_V1'),
      headers: _extends({}, config.getHeaders('RVT_UPGRADE_V1'), {
        Accept: 'application/json'
      })
    })),
    // OSS
    ossExtV2: new Service(_extends({}, config, {
      withRequestId: false,
      headers: config.getHeaders('OSS_EXT_V2'),
      baseURL: config.getBaseURL('OSS_EXT_V2')
    })),
    // Connect to HQ
    adminV1: new Service(_extends({}, config, {
      withRequestId: false,
      headers: _extends({
        Region: config.region
      }, config.getHeaders('HQ_API_ADMIN_V1')),
      baseURL: config.getBaseURL('HQ_API_ADMIN_V1')
    })),
    // Connect to HQ V2
    adminV2: new Service(_extends({}, config, {
      withRequestId: false,
      headers: _extends({
        Region: config.region
      }, config.getHeaders('HQ_API_ADMIN_V2')),
      baseURL: config.getBaseURL('HQ_API_ADMIN_V2')
    })),
    // Connect to ACC Admin
    accAdminV1: new Service(_extends({}, config, {
      withRequestId: false,
      baseURL: config.getBaseURL('ACC_ADMIN_V1'),
      headers: _extends({
        Region: config.region
      }, config.getHeaders('ACC_ADMIN_V1'))
    })),
    // Download from cloudFront
    downloadV2: new Service(_extends({}, config, {
      withCredentials: true,
      headers: config.getHeaders('DOWNLOAD_API_V2'),
      baseURL: "".concat(config.getEnv('DOWNLOAD_HOST')).concat(config.getEnv('DOCS_API_V2'))
    })),
    // PADD
    paddV1: new Service(_extends({}, config, {
      withRequestId: false,
      baseURL: "".concat(config.getEnv('PG_HOST')).concat(config.getEnv('PADD_V1')),
      headers: _extends({}, config.getHeaders('PADD_V1'), {
        Accept: 'application/vnd.plangrid+json; version=1',
        'x-requested-by': 'ACS-Docs SDK JS'
      })
    })),
    paddV2: new Service(_extends({}, config, {
      withRequestId: false,
      baseURL: "".concat(config.getEnv('PG_HOST')).concat(config.getEnv('PADD_V2')),
      headers: _extends({}, config.getHeaders('PADD_V2'), {
        Accept: 'application/vnd.plangrid+json; version=1',
        'x-requested-by': 'ACS-Docs SDK JS'
      })
    })),
    // Oxygen
    oxygenV1: new Service(_extends({}, config, {
      withRequestId: false,
      headers: config.getHeaders('OXYGEN_V1'),
      baseURL: config.getBaseURL('OXYGEN_V1')
    })),
    mdV2: new Service(_extends({}, config, {
      headers: config.getHeaders('MD_V2'),
      baseURL: config.getBaseURL('MD_V2')
    })),
    // Takeoff models publish folder
    qtoV1: new Service(_extends({}, config, {
      headers: _extends({
        'x-ads-region': config.region
      }, config.getHeaders('QTO_V1')),
      baseURL: config.getBaseURL('QTO_V1')
    })),
    dataV1: new Service(_extends({}, config, {
      headers: config.getHeaders('DATA_V1'),
      baseURL: config.getBaseURL('DATA_V1')
    })),
    bcInternal: new Service(_extends({}, config, {
      headers: _extends({}, config.getHeaders('BC_INTERNAL'), [DOCS_ENVS.QA].includes(config.env) && {
        'x-ads-target-server': 'dev'
      }),
      baseURL: config.getBaseURL('BC_INTERNAL')
    })),
    specsV1: new Service(_extends({}, config, {
      withRequestId: false,
      baseURL: config.getBaseURL('SPECS_V1'),
      headers: config.getHeaders('SPECS_V1')
    })),
    automationV1: new Service(_extends({}, config, {
      baseURL: config.getBaseURL('AUTOMATION_V1'),
      headers: _extends({
        'x-ads-region': config.region
      }, config.getHeaders('AUTOMATION_V1'))
    })),
    autoCalloutsV1: new Service(_extends({}, config, {
      withRequestId: false,
      baseURL: "".concat(config.getEnv('PG_HOST')).concat(config.getEnv('BEBOP_V1')),
      headers: _extends({
        'x-ads-region': config.region,
        'x-requested-by': 'ACS-Docs SDK JS',
        Accept: 'application/vnd.plangrid+json; version=1'
      }, config.getHeaders('AUTOCALLOUTS_V1'))
    }))
  };
};